import { searchContextMapper } from '../PdtCtRailsListing';
import { generateUUID } from '@mmt/navigation/src/util';
import { COMMON_EVENT_TRACKING_CONTEXT, EXPERIMENT_DETAILS_CONTEXT } from '../CommonPdtConstants';
import { PDT_SCHEMA_ID, PDT_SCHEMA_NAME } from '../PdtCtRailsListing/PdtCtConstants';
import { logRailsEventToPDT, getJourneyId, transformPayloadForXDM } from '../PdtV2Utils';
import {
  getRailsLandingNewPdtLoggingOnOff,
  getIfToShowFCTGTogether,
} from '../../../../src/RailsAbConfig';
import { logGrafanaErrorMetrics } from 'apps/rails/src/Utils/RailsGrafanaTracker';
import { ENTITY_TYPE, PAGE, NEW_PDT_ERROR_CODES } from 'apps/rails/src/types/grafanaTracking.types';
import { 
  ENTITY,
  CURRENCY_INR,
  LOB_RAILS,
  PAGE_NAME_LANDING,
  PAGE_NAME_HOME,
  PAGE_TYPE_FUNNEL,
  ADDON_TYPE_FREE_CANCELLATION,
  UNIT_TYPE_FREE_CANCELLATION,
  HEADING_FREE_CANCELLATION,
  EVENT_NAME_PAGE_RENDERED,
  EVENT_NAME_BUTTON_CLICKED,
  EVENT_TYPE_PAGE,
  EVENT_VALUE_LANDING_LOAD,
  STORE_ID_MMT,
} from 'apps/rails/src/Utils/RailsConstant';
import { XDMWrapper, TARGETS } from '@gt-common/event-logger-web';
import { RailsLandingPageSchema } from '../../../schemas/railsSchemas';

export const logLandingEvent = async (
  eventvalue: string,
  searchContext: object,
  isFreeCancellationEnabled: boolean,
) => {
  try {
    if (!getRailsLandingNewPdtLoggingOnOff()) {
      return null;
    }

    const freeCancellationEnabled =
      typeof isFreeCancellationEnabled === 'boolean' ? isFreeCancellationEnabled : false;
    const eventDetail = {
      event_name: eventvalue === EVENT_VALUE_LANDING_LOAD ? EVENT_NAME_PAGE_RENDERED : EVENT_NAME_BUTTON_CLICKED,
      event_type: EVENT_TYPE_PAGE,
      event_id: generateUUID(),
      event_timestamp: Date.now(),
      event_value: 'funnel:rails:landing',
      components: {
        id: 'landing_page_load',
      },
    };
    const addon_details = [
      {
        addontype: ADDON_TYPE_FREE_CANCELLATION,
        id: ADDON_TYPE_FREE_CANCELLATION,
        currency: CURRENCY_INR,
        includedunits: freeCancellationEnabled ? 1 : 0,
        unitprice: -1.0,
        unittype: UNIT_TYPE_FREE_CANCELLATION,
        heading: HEADING_FREE_CANCELLATION,
        selected: freeCancellationEnabled,
        available: getIfToShowFCTGTogether(),
        is_preselected: freeCancellationEnabled,
      },
    ];

    const pdtLoggerObj = {
      page_context: {
        lob: LOB_RAILS,
        page_name: PAGE_NAME_LANDING,
      },
      event_tracking_context: {
        ...(await COMMON_EVENT_TRACKING_CONTEXT()),
        template_id: PDT_SCHEMA_ID,
        topic_name: PDT_SCHEMA_NAME,
        ...(await getJourneyId(searchContext)),
      },
      search_context: searchContextMapper(searchContext),
      event_detail: eventDetail,
      addon_details,
    };

    logRailsEventToPDT(pdtLoggerObj);
  } catch (error: any) {
    console.error('Error in logging "Landing" event', error);
    logGrafanaErrorMetrics(
      PAGE.LANDING,
      ENTITY_TYPE.PAGE,
      ENTITY.LANDING_PDT_ERROR_MEASUREMENT_PLATFORM,
      error,
      NEW_PDT_ERROR_CODES.LANDING_LOAD_ERROR_CODE,
    );
  }
};

export const logLandingEventToAll = async (
  eventvalue: string,
  searchContext: object,
  isFreeCancellationEnabled: boolean,
) => {
  try {

    const freeCancellationEnabled =
      typeof isFreeCancellationEnabled === 'boolean' ? isFreeCancellationEnabled : false;
    const eventDetail = {
      event_name: eventvalue === EVENT_VALUE_LANDING_LOAD ? EVENT_NAME_PAGE_RENDERED : EVENT_NAME_BUTTON_CLICKED,
      event_type: EVENT_TYPE_PAGE,
      event_id: generateUUID(),
      event_timestamp: Date.now(),
      event_value: 'funnel:rails:landing',
      components: {
        id: 'landing_page_component',
        component_type: 'landing_page',
      },
    };
    const addon_details = [
      {
        addontype: ADDON_TYPE_FREE_CANCELLATION,
        id: ADDON_TYPE_FREE_CANCELLATION,
        currency: CURRENCY_INR,
        includedunits: freeCancellationEnabled ? 1 : 0,
        unitprice: -1.0,
        unittype: UNIT_TYPE_FREE_CANCELLATION,
        heading: HEADING_FREE_CANCELLATION,
        selected: freeCancellationEnabled,
        available: true,
        is_preselected: freeCancellationEnabled,
      },
    ];

    const pdtLoggerObj = {
      page_context: {
        lob: LOB_RAILS,
        page_type: PAGE_TYPE_FUNNEL,
        page_name: PAGE_NAME_LANDING,
        prev_page_name: PAGE_NAME_HOME,
        funnel_step: PAGE_NAME_LANDING,
        lob_category: LOB_RAILS,
        travel_store: {
          store_id: STORE_ID_MMT
        }
      },
      event_tracking_context: {
        ...(await COMMON_EVENT_TRACKING_CONTEXT()),
        template_id: PDT_SCHEMA_ID,
        topic_name: PDT_SCHEMA_NAME,
        ...(await getJourneyId(searchContext)),
      },
      search_context: searchContextMapper(searchContext),
      event_detail: eventDetail,
      addon_details,
      ...(EXPERIMENT_DETAILS_CONTEXT() || {}),
    };

    await XDMWrapper.logEvent({
      payload: transformPayloadForXDM(pdtLoggerObj),
      schema: RailsLandingPageSchema,
      otherConfig: { 
        lobName: LOB_RAILS,
        adobeKeyConfig: [] 
      },
      target: TARGETS.ALL,
      extraOptions: {
        lob: LOB_RAILS,
        destinationUrl: typeof window !== 'undefined' ? window.location.href : ''
      }
    });

  } catch (error: any) {
    console.error('Error in logging landing event to all platforms', error);
    logGrafanaErrorMetrics(
      PAGE.LANDING,
      ENTITY_TYPE.PAGE,
      ENTITY.LANDING_PDT_ERROR_MEASUREMENT_PLATFORM,
      error,
      NEW_PDT_ERROR_CODES.LANDING_LOAD_ERROR_CODE,
    );
  }
};
